// 获取用户答案
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IInput {
    _type: number; // 新老考试的区分
    element_id: number;
    question_ids: string;
    student_id?: number;
    user_id?: string;
    is_finished?: number;
}

export const getUserAnswerList = (data: IInput): Promise<IServerUserQuizResultMap> => {
    return fetchData(Api.GET_QUIZ_USER_ANSWER_LIST, data)
        .then((res: IResponse<IServerUserQuizResultMap>) => {
            return res.data || {};
        })
        .catch(() => {
            return {};
        });
};
